import $ from 'jquery';
import { scrollToElement } from './lib/utilities';

$(() => {
  // if first rating, scroll to rate
  if ($('.ratings-count--first').length > 0) {
    $('.ratings-count, .card__rating').hide();

    $('.ratings-count--first').on('click', function () {
      scrollToElement($('#reply-title'));
    });
  } else {
    $('.ratings-count').on('click', function () {
      scrollToElement($('#reply-title'));
    });
  }

  let $rating = $(
    '.comment-respond .comments__recipe-rating .card__rating button'
  );

  $rating.on('click', function () {
    $rating = $(this);
    const { rating, disabled } = $rating.data();
    const data = {
      rating,
      disabled
    };

    userRating();

    function userRating() {
      const $newRatingStarsRed = $rating.prevAll().addBack();
      const $newRatingStarsGray = $rating.nextAll();

      $newRatingStarsRed.children('i').removeClass().addClass('icon-star-red');

      $newRatingStarsGray
        .children('i')
        .removeClass()
        .addClass('icon-star-gray');

      $rating.parents($('.rating-value').val(data.rating));
    }
  });

  const $commentForm = $('#commentform');
  const $commentText = $('#comment');
  const formHelp = document.getElementById('comment_image--error');

  // add enctype="multipart/form-data" to form
  $commentForm.attr('enctype', 'multipart/form-data');

  $commentForm.on('submit', function (event) {
    formHelp.textContent = '';
    if ($commentText.val() === '') {
      $commentText.val('N/A');
    }

    const $file = document.getElementById('comment_image');
    const file = $file.files[0];

    if (file && file.size > 3000000) {
      event.preventDefault();
      formHelp.textContent = 'File size must be less than 3MB';
    }

    return true;
  });
});

// after page load
$(window).on('load', function () {});
